<div class="container">
  <div>
    <ion-row>





      <ion-col size="12">

        <!-- <div *ngIf="setupNotCompleted" style="color: red;">
          Not Completed Set Up
        </div> -->
        <button type="button" class="add_btn fs-14 fs_12ForMobile float-right center-content mr-5"
          [style.background-color]="buttonColorName" (click)="addCandidate()" [disabled]="chechsetupStatus"
          [ngStyle]="chechsetupStatus ? {'opacity': '0.5', 'pointer-events': 'none'} : {}">
          <span class="material-icons fs-20 mr-5">add</span>Add Candidate</button>


      </ion-col>
    </ion-row>
  </div>
  <div class="cardBox mb-20 p-10">


    <ion-row>
      <ion-col size>
        <mat-form-field class="w-100 max-w-220 mat-height40 mat-input-style">
          <mat-icon matPrefix>search</mat-icon>
          <input matInput type="search" placeholder="Search" [(ngModel)]="searchTerm" (input)="filterEmployees()">
        </mat-form-field>
      </ion-col>
      <ion-col size="auto">
        <div class="phi-flex-wrap-center phi-gap-12">

          <!-- <ion-col size class="phi-align-items-center"> -->
          <label class="phi-flex phi-gap-6 phi-align-items-center">
            <ion-label class="fs-14 fs_12ForMobile font_regular black_color">Show</ion-label>
            <mat-form-field class="w-100 max-w-75 mat-height40 mat-input-style" >
              <mat-select placeholder="Select"   [(ngModel)]="selectedSize" placeholder="Select" (selectionChange)="DislaySelectedRecord($event)">
            
                <mat-option [value]="25">25</mat-option>
                <mat-option [value]="50">50</mat-option>
                <mat-option [value]="75">75</mat-option>
                <mat-option [value]="100">100</mat-option>
              </mat-select>
            </mat-form-field>
            <ion-label class="fs-14 fs_12ForMobile font_regular black_color">entries</ion-label>
          </label>

          <div>
            <span class="icon-download fs-20 material-icons" (click)="downloadEmployeeList()">download</span>
          </div>
        </div>
      </ion-col>

      <!-- <ion-col size="auto">
        <div class="d-flex justify-content-flex-end ">
          <div class="d-flex" style="margin-right: 15px; margin-top: 10px;">
            <span class="ml-5 mr-5 icon-download fs-20 material-icons" (click)="downloadEmployeeList()">download</span>
          </div>
        </div>
      </ion-col> -->
    </ion-row>


    <div>
      <ion-row>
        <ion-col size="12">
          <div class="table-container">
            <table>
              <thead>
                <tr>

                  <th *ngFor="let item of OfferAndAppointmentTableHeader"
                    class="fs-14 fs_12ForMobile font_bold cl-black">
                    <div class="p-5 verticle-center justify-content-space-between icon-style">
                      {{ item?.label }}

                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let employee of employees; let i = index">
                  <td>{{ i + 1 }}</td>
                  <td>{{ employee.salutation }}</td>
                  <!-- <td class="name"
                  [ngClass]="{'disabled': employee.status === 'OFFER_LETTER_SENT' || employee.status === 'APPROVED_APPOINTMENT_LETTER'}"
                  [ngStyle]="{'color': 'orange', 'text-decoration': 'underline', 'cursor': (employee.status === 'OFFER_LETTER_SENT' || employee.status === 'APPROVED_APPOINTMENT_LETTER') ? 'default' : 'pointer'}"
                  (click)="(employee.status !== 'OFFER_LETTER_SENT' && employee.status !== 'APPROVED_APPOINTMENT_LETTER') ? employeeApplicationForm(employee) : null"
                > -->
                  <td class="name" [ngClass]="{'disabled': employee.status === 'APPROVED_APPOINTMENT_LETTER'}"
                    [ngStyle]="{'color': 'orange', 'text-decoration': 'underline', 'cursor': (checkSendOfferLetterFlag || employee.status === 'APPROVED_APPOINTMENT_LETTER') ? 'default' : 'pointer'}"
                    (click)="(employee.status !== 'APPROVED_APPOINTMENT_LETTER') ? employeeApplicationForm(employee) : null">
                    {{ employee.firstName }}
                  </td>


                  <!-- <td (click)="employeeApplicationForm(employee)"style="color: orange; text-decoration: underline; cursor: pointer;"
                  [disabled]="employee.status!='OFFER_LETTER_SENT' || employee.status=='APPROVED_APPOINTMENT_LETTER'">{{ employee.firstName}}</td> -->
                  <td>{{ employee.lastName }}</td>
                  <td>{{ employee.candidateEmail }}</td>
                  <td> {{ formatedataVariable(employee.status) }}</td>
                  <td>

                    <!-- <div class="phi-flex-center phi-gap-12 w-max-content">
                    <img src="././assets/icon/blueEyeIcon.svg" matTooltip="View offer Letter" class="cp"
                      (click)="viewOferLatter(employee)" *ngIf="!appointment"
                      [ngClass]="{'disabled': employee.status == 'FILLED_BY_EMPLOYEE_PENDING_BY_HR'||employee.status == 'NOT_FILLED_BY_EMPLOYEE'}||employee.fileName!=null||isLoading">
                   
                    <mat-icon matTooltip="Earlier Offer Letter Sent" class="info-bordered-icon phi-align-content-center"
                      (click)="offerLetterPriview(employee)"
                      *ngIf="employee.status === 'OFFER_LETTER_SENT' || employee.status === 'APPROVED_APPOINTMENT_LETTER'">
                      info
                    </mat-icon>

                    <mat-icon matTooltip="Send Offer Letter" class="info-bordered-icon cp phi-align-content-center"
                      (click)="sendOfferLetter(employee)"
                      *ngIf="!appointment && !loadingCandidateId.has(employee.candidateId)"
                      [ngClass]="{ 'disabled': isDisabledToSendOffer(employee) }">
                      send
                    </mat-icon>

                    <mat-spinner diameter="21" *ngIf="loadingCandidateId.has(employee.candidateId)"
                      style="display: inline-block;  margin-top: -10px; margin-left: 10px;">
                    </mat-spinner>
                   
                    <button type="button" class="add_btn fs-14 fs_12ForMobile center-content mr-5 custom-disabled-button"
                      [disabled]="employee.status!='OFFER_LETTER_SENT'" [style.background-color]="'green'"
                      *ngIf="!appointment" (click)="convertEmployeeCode(employee)">
                      Convert</button>
                    <button type="button" class="add_btn fs-14 fs_12ForMobile center-content mr-5 custom-disabled-button"
                      [disabled]="employee.status!='FILLED_BY_HR'" [style.background-color]="'green'"
                      *ngIf="appointment" (click)="convertEmployeeCode(employee)">
                      Convert</button>
                      </div> -->

                    <div class="phi-flex-center phi-gap-12 w-max-content">

  <!-- View Offer Letter Icon -->
  <img
    src="././assets/icon/blueEyeIcon.svg"
    matTooltip="View Offer Letter"
    class="cp"
    (click)="viewOferLatter(employee)"
    [style.visibility]="!appointment ? 'visible' : 'hidden'"
    [ngClass]="{
      'disabled': employee.status === 'FILLED_BY_EMPLOYEE_PENDING_BY_HR' || 
                  employee.status === 'NOT_FILLED_BY_EMPLOYEE' ||  isLoading
    }"
  />

  <!-- Earlier Offer Letter Info Icon -->
  <mat-icon  *ngIf="!appointment"
    matTooltip="Earlier Offer Letter Sent"
    class="info-bordered-icon phi-align-content-center"
    (click)="offerLetterPriview(employee)"
    [style.visibility]="(employee.status === 'OFFER_LETTER_SENT' || employee.status === 'APPROVED_APPOINTMENT_LETTER') ? 'visible' : 'hidden'"
  >
    info
  </mat-icon>

 <!-- Send Offer Letter / Spinner Wrapper -->
<!-- Send Offer Letter / Spinner Wrapper -->
<span
  class="offer-action-wrapper"
  style="position: relative; display: inline-block; width: 36px; height: 36px;"
>
  <!-- Icon -->
  <mat-icon
     *ngIf="!appointment && !loadingCandidateId.has(employee.candidateId)"
    matTooltip="Send Offer Letter"
    class="info-bordered-icon cp phi-align-content-center"
    (click)="sendOfferLetter(employee)"
    [ngClass]="{ 'disabled': isDisabledToSendOffer(employee) }"
    style="width: 100%; height: 100%; display: flex; align-items: center; justify-content: center;"
  >
    send
  </mat-icon>

  <!-- Spinner -->
  <mat-spinner
    *ngIf="loadingCandidateId.has(employee.candidateId)"
    diameter="21"
    style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);"
  >
  </mat-spinner>
</span>



  <!-- Convert Button -->
  <button
    type="button"
    class="add_btn fs-14 fs_12ForMobile center-content mr-5 custom-disabled-button"
    [disabled]="appointment ? employee.status !== 'FILLED_BY_HR' : employee.status !== 'OFFER_LETTER_SENT'"
    [style.background-color]="'green'"
    [style.visibility]="'visible'"  
    (click)="convertEmployeeCode(employee)"
  >
    Convert
  </button>

</div>



                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </ion-col>
      </ion-row>
    </div>
  </div>
</div>